export var RoomType = /*#__PURE__*/ function(RoomType) {
    RoomType[RoomType["Standard"] = 0] = "Standard";
    RoomType[RoomType["FreeMap"] = 1] = "FreeMap";
    RoomType[RoomType["BeginnerMode"] = 2] = "BeginnerMode";
    RoomType[RoomType["CustomLink"] = 3] = "CustomLink";
    RoomType[RoomType["DiscordActivity"] = 4] = "DiscordActivity";
    RoomType[RoomType["Tournament"] = 5] = "Tournament";
    return RoomType;
}({});
export const TOURNAMENT_ROOM_KEYWORDS = [
    'event',
    'tourney',
    'ecl'
] // Keep keyword length <= 8
;
export var RoomCreationPhase = /*#__PURE__*/ function(RoomCreationPhase) {
    RoomCreationPhase[RoomCreationPhase["EditSettings"] = 0] = "EditSettings";
    RoomCreationPhase[RoomCreationPhase["SeedOrderSelection"] = 1] = "SeedOrderSelection";
    RoomCreationPhase[RoomCreationPhase["PlayOrderSelection"] = 2] = "PlayOrderSelection";
    return RoomCreationPhase;
}({});
